import {sendEventInteraction} from "../libs/apiv2-requests";

export default context => {
    $('#window-add_to_calendar a', context).on('click', () => sendEventInteraction('save'))
}
